export const CTA_URL =
  'https://colorpack.online/cart/48141846184075:1?storefront=true'

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/iAQz51V7JeaTLryo23riVM/karito_educa_logo_sin_fondo.png'

export const HERO_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/1cnzvsjBuQYUHBif465x33/metodo_domingo_libre_sin_fondo.png'

export const BONO1_URL =
  'https://cdn.magicpatterns.com/uploads/jL2wCWCQHuxhA2iie65Q9H/bono1_domingo.png'

export const BONO2_URL =
  'https://cdn.magicpatterns.com/uploads/nSw76zr7Jt48Gr3K4Ms5zg/bono2_domingo.png'

export const BONO3_URL =
  'https://cdn.magicpatterns.com/uploads/8Fxja2ayBC2BeoQKo5YkD7/bono3_domingo.png'

export const BONO4_URL =
  'https://cdn.magicpatterns.com/uploads/9u9ojGU7E7tCKsfu8gTnqq/bono_4_domingo.png'

export const BONO5_URL =
  'https://cdn.magicpatterns.com/uploads/q9xrWczuT12K5N2pYq3ysy/bono_5_domingo.png'

export const BONO6_URL =
  'https://cdn.magicpatterns.com/uploads/wrj5qnTc9sYVionQFsT57m/bono6_domingo.png'

export function goToCart() {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', 'InitiateCheckout')
  }
  window.location.href = CTA_URL
}
